import {Subject} from 'rxjs';

let rendererId = 0;
/**
 * Interface for components that render to a canvas element
 */
export abstract  class CanvasRenderer {
  private _id: number;
  private _priority: number;
  private _destroyed$ = new Subject<void>();
  protected canvas: HTMLCanvasElement | null = null;

  protected constructor(priority: number) {
    this._priority = priority;
    this._id = rendererId++;
  }

  /**
   * Initializes the renderer with a canvas element
   * @param canvas Canvas element to render on
   */
  initialize(canvas: HTMLCanvasElement): void {
    this.canvas = canvas;
  }

  /**
   * Renders content to the canvas
   */
  abstract render(): void;

  /**
   * Name of the renderer for debugging purposes
   */
  abstract readonly name: string;

  destroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  /**
   * Gets the destroyed observable
   */
  get destroyed$() {
    return this._destroyed$.asObservable();
  }

  /**
   * Priority of the renderer which determines drawing order
   * Higher priority renderers are drawn after (on top of) lower priority renderers
   */
  get priority(): number {
    return this._priority;
  }

  /**
   * Unique identifier for the renderer
   */
  get id(): number {
    return this._id;
  }
}
